import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  openLineLink() {
		window.open('https://line.me/ti/g2/HfIi-mq0xL-WHwGEEFe10B9NTvZASH6YzEfWdw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default', '_blank');
	}

  openIgLink() {
		window.open('https://www.instagram.com/bigaunts_sports/?utm_source=ig_web_button_share_sheet', '_blank');
	}
}
